export const locationActions = {
  populateLocations: "POPULATE_LOCATIONS"
};
